const styles = {
  checkboxWrapper: {
    marginBottom: 0,
    padding: 12,
    borderBottom: '1px solid rgba(0, 0, 0, 0.15)',
  },
  checkboxWrapperDisable: {
    marginBottom: 0,
    padding: 12,
    borderBottom: '1px solid rgba(0, 0, 0, 0.15)',
    background: 'rgba(200, 200, 200, 0.2)',
  },
  recipientIconButton: {
    height: 24,
    margin: 0,
    padding: 0,
    width: 22,
    zIndex: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  shareDetailsTitle: {
    position: 'absolute',
    background: '#fff',
    padding: '0 5px',
    top: 2,
    left: 8,
    zIndex: 10,
  },
  shareMessage: {
    width: '100%',
    minHeight: 88,
    padding: 12,
    fontSize: 13,
    lineHeight: '20px',
  },
  tooltip: {
    position: 'relative',
  },
} as const;

export default styles;
